export default {
  path: "/chart",
  name: "chart",
  component: {
    template: `<router-view></router-view>`
  },
  children: [
    {
      path: "general",
      name: "chart/general",
      component: () => import("@/components/Charts/GeneralReport"),
      meta: {
        can: "admin::chart:general-report"
      }
    },
    {
      path: "agent_transactions_and_tua_profit_dynamics",
      name: "chart/agent_transactions_and_tua_profit_dynamics",
      component: () =>
        import("@/components/Charts/AgentTransactionsAndTuaProfitDynamics"),
      meta: {
        can: "admin::chart:agent-transactions-and-tua-profit-dynamics"
      }
    },
    {
      path: "sales_and_profit_by_providers",
      name: "chart/sales_and_profit_by_providers",
      component: () => import("@/components/Charts/SalesAndProfitByProviders"),
      meta: {
        can: "admin::chart:sales-and-profit-by-providers"
      }
    },
    {
      path: "sales_and_profit_dynamics_by_providers",
      name: "chart/sales_and_profit_dynamics_by_providers",
      component: () =>
        import("@/components/Charts/SalesAndProfitDynamicsByProviders"),
        meta: {
          can: "admin::chart:sales-and-profit-dynamics-by-providers"
        }
    },
    {
      path: "sales_and_agents_deposites_dynamic",
      name: "chart/sales_and_agents_deposites_dynamic",
      component: () =>
        import("@/components/Charts/SalesAndAgentsDepositesDynamic"),
        meta: {
          can: "admin::chart:sales-and-agents-deposites-dynamic"
        }
    },
    {
      path: "agents_deposits_and_profit_balance",
      name: "chart/agents_deposits_and_profit_balance",
      component: () =>
        import("@/components/Charts/AgentsDepositsAndProfitBalance"),
        meta: {
          can: "admin::chart:agents-deposits-and-profit-balance"
        }
    },
    {
      path: "sales_by_airtime_credit",
      name: "chart/sales_by_airtime_credit",
      component: () => import("@/components/Charts/SalesByAirtimeCredit"),
      meta: {
        can: "admin::chart:sales-by-airtime-credit"
      }
    },
    {
      path: "number_of_tua_accounts",
      name: "chart/number_of_tua_accounts",
      component: () => import("@/components/Charts/NumberOfTUAAccounts"),
      meta: {
        can: "admin::chart:number-of-tua-accounts"
      }
    },
    {
      path: "monthly_total_sales",
      name: "chart/monthly_total_sales",
      component: () => import("@/components/Charts/MonthlyTotalSales"),
      meta: {
        can: "admin::chart:monthly-total-sales"
      }
    },
    {
      path: "monthly_average",
      name: "chart/monthly_average",
      component: () => import("@/components/Charts/MonthlyAverageReport"),
      meta: {
        can: "admin::chart:monthly-average-report"
      }
    },
    {
      path: "agents_sales",
      name: "chart/agents_sales",
      component: () => import("@/components/Charts/AgentsSales"),
      meta: {
        can: "admin::chart:agents-sales"
      }
    },
    {
      path: "users_and_referals",
      name: "chart/users_and_referals",
      component: () => import("@/components/Charts/UsersAndReferals"),
      meta: {
        can: "admin::chart:users-and-referals"
      }
    },
    {
      path: "company-assets",
      name: "chart/company-assets",
      component:() =>import("@/components/Charts/Assets"),
      meta: {
        can: "admin::chart:company-assets"
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/chart.js